// import './App.css';
import { Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminLayout from "./layouts/AdminLayout";
import PropOwnerLayout from "./layouts/PropOwnerLayout";
import TenantLayout from "./layouts/TenantLayout";
import WebsiteLayout from "./layouts/WebsiteLayout";
import Dashboard from "./pages/admin/dashboard/Dashboard";
import Users from "./pages/admin/management/userManagement/Users";
import NotifyEmail from "./pages/admin/management/notification/NotifyEmail";
import NotifySms from "./pages/admin/management/notification/NotifySms";
import NotifyWhatsapp from "./pages/admin/management/notification/NotifyWhatsapp";
import Subscription from "./pages/admin/finances/subscription/Subscription";
import PackageList from "./pages/admin/finances/packages/PackageList";
import CreatePackage from "./pages/admin/finances/packages/CreatePackage";
import FundRequest from "./pages/admin/finances/fundRequests/FundRequest";
import ReportAndAnalytics from "./pages/admin/finances/reportAndAnalytics/ReportAndAnalytics";
import BillTypeMaster from "./pages/admin/system/billTypeMaster/BillTypeMaster";
import SmsApi from "./pages/admin/system/apiSettings/SmsApi";
import WhatsappApi from "./pages/admin/system/apiSettings/WhatsappApi";
import EmailSetting from "./pages/admin/system/apiSettings/EmailSetting";
import AmenitiesMaster from "./pages/admin/system/amenitiesMaster/AmenitiesMaster";
import PaymentModes from "./pages/admin/system/paymentModes/PaymentModes";
import PaymentInstruments from "./pages/admin/system/paymentInstruments/PaymentInstruments";
import GatewayList from "./pages/admin/system/paymentGateway/GatewayList";
import GatewayRouting from "./pages/admin/system/paymentGateway/GatewayRouting";
import SystemSetting from "./pages/admin/system/systemSetting/SystemSetting";
import WebsiteSetting from "./pages/admin/system/websiteSetting/WebsiteSetting";
import Login from "./pages/auth/Login";
import TenantDashboard from "./pages/tenant/dashboard/TenantDashboard";
import MyBills from "./pages/tenant/myAccount/mybills/MyBills";
import PayRent from "./pages/tenant/myAccount/payRent/PayRent";
import PaymentHistory from "./pages/tenant/myAccount/paymentHistory/PaymentHistory";
import KycDocuments from "./pages/tenant/myAccount/kycDocuments/KycDocuments";
import Complaints from "./pages/tenant/myAccount/complaints/Complaints";
import MyWallet from "./pages/tenant/account/mywallet/MyWallet";
import PropOwnerDashboard from "./pages/propOwner/dashboard/PropOwnerDashboard";
import Buildings from "./pages/propOwner/properties/Buildings";
import Rooms from "./pages/propOwner/properties/Rooms";
import PgDashboard from "./pages/propOwner/pgManagement/PgDashboard.jsx";
import PgProperties from "./pages/propOwner/pgManagement/PgProperties.jsx";
import PgRoomAndBed from "./pages/propOwner/pgManagement/PgRoomAndBed.jsx";
import PgSharingType from "./pages/propOwner/pgManagement/PgSharingType.jsx";
import PgFoodManagement from "./pages/propOwner/pgManagement/PgFoodManagement.jsx";
import OwnerTenants from "./pages/propOwner/tenants/OwnerTenants.jsx";
import KycDocSettings from "./pages/propOwner/tenants/KycDocSettings.jsx";
import Billing from "./pages/propOwner/finance/Billing.jsx";
import OwnerPayments from "./pages/propOwner/finance/OwnerPayments.jsx";
import FundRequests from "./pages/propOwner/finance/FundRequests";
import OwnerPaymentInstruments from "./pages/propOwner/finance/OwnerPaymentInstruments.jsx";
import PaymentGateway from "./pages/propOwner/finance/PaymentGateway.jsx";
import OwnerNotifyEmail from "./pages/propOwner/notifications/OwnerNotifyEmail.jsx";
import OwnerNotifySms from "./pages/propOwner/notifications/OwnerNotifySms.jsx";
import OwnerNotifyWhatsapp from "./pages/propOwner/notifications/OwnerNotifyWhatsapp.jsx";
import OwnerSmsApi from "./pages/propOwner/apiSettings/OwnerSmsApi.jsx";
import OwnerWhatsappApi from "./pages/propOwner/apiSettings/OwnerWhatsappApi.jsx";
import OwnerEmailSetting from "./pages/propOwner/apiSettings/OwnerEmailSetting.jsx";
import OwnerBillTypeMaster from "./pages/propOwner/settings/OwnerBillTypeMaster.jsx";
import OwnerMyWallet from "./pages/propOwner/accounts/OwnerMyWallet.jsx";
import MySubscription from "./pages/propOwner/accounts/MySubscription.jsx";
import AdminProfile from "./pages/admin/adminProfile/AdminProfile.jsx";
import TenantProfile from "./pages/tenant/tenantProfile/TenantProfile.jsx";
import VacateNotice from "./pages/tenant/myAccount/vacateNotice/VacateNotice.jsx";
import SupportTicket from "./pages/tenant/support/supTicket/SupportTicket.jsx";
import VacateRequest from "./pages/propOwner/tenants/VacateRequest.jsx";
import SupportTicketReq from "./pages/propOwner/tenants/SupportTicketReq.jsx";
import Features from "./pages/website/features/Features.jsx";
import Pricing from "./pages/website/pricing/Pricing.jsx";
import Contact from "./pages/website/contact/Contact.jsx";
import Home from "./pages/website/home/Home.jsx";
import MyCommunicationSettings from "./pages/propOwner/apiSettings/MyCommunicationSettings.jsx";

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<WebsiteLayout />}>
          <Route index element={<Home />} />
          <Route path="features" element={<Features />} />
          <Route path="pricing" element={<Pricing />} />
          <Route path="contact" element={<Contact />} />
        </Route>
        <Route path="/login" element={<Login />} />
        {/* ── Admin routes ── role="SaasAdmin" ── */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={["SaasAdmin"]}>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="profile" element={<AdminProfile />} />
          <Route path="user-list" element={<Users />} />
          <Route path="notify-via-email" element={<NotifyEmail />} />
          <Route path="notify-via-sms" element={<NotifySms />} />
          <Route path="notify-on-whatsapp" element={<NotifyWhatsapp />} />
          <Route path="subscription" element={<Subscription />} />
          <Route path="package-list" element={<PackageList />} />
          <Route path="create-package" element={<CreatePackage />} />
          <Route path="fund-request" element={<FundRequest />} />
          <Route path="reports-analytics" element={<ReportAndAnalytics />} />
          <Route path="bill-type-master" element={<BillTypeMaster />} />
          <Route path="sms-api" element={<SmsApi />} />
          <Route path="whatsapp-api" element={<WhatsappApi />} />
          <Route path="email-setting" element={<EmailSetting />} />
          <Route path="amenities-master" element={<AmenitiesMaster />} />
          <Route path="payment-modes" element={<PaymentModes />} />
          <Route path="payment-instruments" element={<PaymentInstruments />} />
          <Route path="gateway-list" element={<GatewayList />} />
          <Route path="gateway-routing" element={<GatewayRouting />} />
          <Route path="system-setting" element={<SystemSetting />} />
          <Route path="website-setting" element={<WebsiteSetting />} />
        </Route>

        {/* ── Property owner routes ── role="owner" ── */}
        <Route
          path="/owner"
          element={
            <ProtectedRoute allowedRoles={["PropertyOwner"]}>
              <PropOwnerLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="profile" element={<AdminProfile />} />
          <Route path="dashboard" element={<PropOwnerDashboard />} />
          <Route path="buildings" element={<Buildings />} />
          <Route path="rooms" element={<Rooms />} />
          <Route path="pg-dashboard" element={<PgDashboard />} />
          <Route path="pg-properties" element={<PgProperties />} />
          <Route path="pg-room-bed" element={<PgRoomAndBed />} />
          <Route path="pg-sharing-type" element={<PgSharingType />} />
          <Route path="pg-food-management" element={<PgFoodManagement />} />
          <Route path="propown-tenants" element={<OwnerTenants />} />
          <Route path="kyc-doc-settings" element={<KycDocSettings />} />
          <Route path="vacate-request" element={<VacateRequest />} />
          <Route path="support-ticket-request" element={<SupportTicketReq />} />
          <Route path="billing" element={<Billing />} />
          <Route path="propown-payments" element={<OwnerPayments />} />
          <Route path="fund-requests" element={<FundRequests />} />
          <Route
            path="payment-instruments"
            element={<OwnerPaymentInstruments />}
          />
          <Route path="payment-gateway" element={<PaymentGateway />} />
          <Route
            path="propown-notify-on-whatsapp"
            element={<OwnerNotifyWhatsapp />}
          />
          <Route
            path="propown-notify-via-email"
            element={<OwnerNotifyEmail />}
          />
          <Route path="propown-notify-via-sms" element={<OwnerNotifySms />} />
          <Route
            path="propown-comm-settings"
            element={<MyCommunicationSettings />}
          />
          <Route path="propown-sms-api" element={<OwnerSmsApi />} />
          <Route path="propown-whatsapp-api" element={<OwnerWhatsappApi />} />
          <Route path="propown-email-setting" element={<OwnerEmailSetting />} />
          <Route
            path="propown-bill-type-master"
            element={<OwnerBillTypeMaster />}
          />
          <Route path="propown-my-wallet" element={<OwnerMyWallet />} />
          <Route path="my-subscription" element={<MySubscription />} />
        </Route>

        {/* ── Tenant routes ── role="tenant" ── */}

        <Route
          path="/tenant"
          element={
            <ProtectedRoute allowedRoles={["Tenant"]}>
              <TenantLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<TenantDashboard />} />
          <Route path="tenant-profile" element={<TenantProfile />} />
          <Route path="my-bills" element={<MyBills />} />
          <Route path="pay-rent" element={<PayRent />} />
          <Route path="payment-history" element={<PaymentHistory />} />
          <Route path="vacate-notice" element={<VacateNotice />} />
          <Route path="kyc-documents" element={<KycDocuments />} />
          <Route path="complaints" element={<Complaints />} />
          <Route path="support-tickets" element={<SupportTicket />} />
          <Route path="my-wallet" element={<MyWallet />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
